import RegisteredUsers from "../../../jsx/components/Dashboard/RegisteredUsers/registeredUsers";

const RegisteredUsersWrapper = () => {
  return <RegisteredUsers />;
};

export default constore(RegisteredUsersWrapper);
